/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-27 20:04:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-27 20:05:30
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/TextArea/BlurTriggerTextArea.tsx
 */
import React from 'react';

import TextArea from './TextArea';

const BlurTriggerTextArea = (props) => {
  const { onFocus, value, onChange, ...rest } = props;
  const [text, setText] = React.useState(value);
  React.useEffect(() => {
    if (value !== text) {
      setText(value);
    }
  }, [value]);
  const handleOnChange = () => {
    if (onChange) onChange(text);
  };
  return (
    <TextArea
      onFocus={onFocus}
      onChange={setText}
      value={text}
      onBlur={handleOnChange}
      {...rest}
    />
  );
};
export default BlurTriggerTextArea;
